const AudioMap = require('AudioMap');

const State = cc.Enum({
        OPEN_POPUP: 'openPopup',
        CLOSE_POPUP: 'closePopup',
        IDLE: 'idle'
    });

cc.Class({
    extends: cc.Component,

    properties: {
        label: cc.Label,
        totalCountLabel: cc.Label,
        skeleton: sp.Skeleton,
    },

    onLoad() {
        this.audioMap = cc.find('AudioMap').getComponent(AudioMap);

        // this.state = State.IDLE;
        // this.onLandscape();
    },


    increment() {
        this.setFreespins(this.freespins + 1 );
    },


    setFreespins(freespins, totalCount) {
        if (this.node.active) {
            this.audioMap.playSfx('fsRoundCounter');
        }
        this.state = State.IDLE;
        this.label.node.active = true;
        this.freespins = freespins;
        if (totalCount) {
            this.totalCount = totalCount;
        }

        this.skeleton.setAnimation(0, 'match', false);
        this.skeleton.addAnimation(0, 'idle', true);
        cc.tween(this.label.node).delay(0.1).to(0.1, { scaleX: 0, scaleY: 0, opacity: 0 }).
            call(() => {
                this.label.string = this.freespins;
                this.totalCountLabel.string = this.totalCount;
            }).
            to(0.1, { scaleX: -1, scaleY: 1, opacity: 255 }).start();
    },

    totalFreespins (count) {
        if (count > 0) {
            this.totalCount = count;
            this.totalCountLabel.string = count;
        } else {
            this.totalCount = '∞';
            this.totalCountLabel.string = '∞';

        }
    },

    getFreespins() {
        return this.freespins;
    },

    show() {
        this.node.active = true;
        this.node.opacity = 0;
        this.skeleton.setAnimation(0, 'idle', true);
        cc.tween(this.node).to(0.2, { opacity: 255 }).delay(2).start();
    },

    hide() {
        cc.tween(this.node).to(0.2, { opacity: 0 }).call(() => {
            this.node.active = false;
        }).start();
    },

});
